export const replaceElementByIndex = (arr, index, newElement) => {
  return [...arr.slice(0, index), newElement, ...arr.slice(index + 1)];
};

export const deleteElementByIndex = (arr, index) => {
  return [...arr.slice(0, index), ...arr.slice(index + 1)];
};

export const removeElement = (array, element) => {
  const index = array.indexOf(element);
  return deleteElementByIndex(array, index);
};

export const removeElements = (array, elements) => {
  return elements.reduce((prev, curr) => {
    return removeElement(prev, curr);
  }, array);
};

export const swapItems = (items, firstIndex, secondIndex) => {
  // Constant reference - we can still modify the array itself
  const results = items.slice();
  const firstItem = items[firstIndex];
  results[firstIndex] = items[secondIndex];
  results[secondIndex] = firstItem;

  return results;
};



// WEBPACK FOOTER //
// ./src/utils/arrayHelpers.js